import { render, staticRenderFns } from "./RegisterSoldPopup.vue?vue&type=template&id=20ce3942&scoped=true&"
import script from "./RegisterSoldPopup.vue?vue&type=script&lang=js&"
export * from "./RegisterSoldPopup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popup.css?vue&type=style&index=0&id=20ce3942&scoped=true&lang=css&"
import style1 from "./RegisterSoldPopup.vue?vue&type=style&index=1&id=20ce3942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce3942",
  null
  
)

export default component.exports